const productSlider = {
  init() {
    $('.js-product-slider').slick({
      dots: false,
      infinite: false,
      speed: 1500,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      rows: 0,
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    // $('body').each(function() {
    //   $('.product-card').matchHeight({
    //     byRow: true,
    //     property: 'height',
    //     target: null,
    //     remove: false,
    //   });
    // });

    $('.js-product-slider:first').addClass('selected');

    $('.sector-tabs .sector-btn').on('click', function(e) {
      e.preventDefault();
      $('.js-product-slider').removeClass('selected');

      var index = $(this).index();

      $('.js-product-slider:eq(' + index + ')').addClass('selected').slick('refresh');

      $('.sector-tabs .sector-btn').removeClass('selected');

      $(this).addClass('selected');
    });
  },
};

export default productSlider;



// WEBPACK FOOTER //
// ./scripts/blocks/product-slider.js